import React, { useEffect } from "react";
import { designer } from "../mock";
import Header from "../components/Header";
import { useEdgeSwipeBack } from "../lib/useEdgeSwipeBack";

const About = () => {
  useEdgeSwipeBack();
  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);

  return (
    <main className="bg-paper text-ink min-h-screen">
      <Header />

      <section className="pt-28 md:pt-40 pb-20 md:pb-28 px-10 md:px-20">
        <div className="max-w-[1700px] mx-auto grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12 items-stretch">
          {/* LEFT — picture */}
          <div className="md:col-span-6 lg:col-span-5">
            <div className="aspect-[4/5] w-full overflow-hidden bg-[#EFEDE6]">
              <img
                src={designer.portrait}
                alt={designer.name}
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          {/* RIGHT — description, fits within picture height */}
          <div className="md:col-span-6 lg:col-span-7 flex flex-col justify-center md:py-2">
            <div>
              <p
                className="text-xs uppercase tracking-widest text-muted-ink mb-6"
                style={{ fontFamily: "'Avenir Next', 'Avenir', 'Nunito Sans', 'Inter', sans-serif", fontWeight: 400 }}
              >
                About
              </p>

              <h1 className="serif font-light tracking-tight leading-[1.05] text-3xl md:text-4xl lg:text-5xl xl:text-6xl">
                Design Lead
                <span className="block serif-italic text-muted-ink mt-1">
                  and product strategist.
                </span>
              </h1>

              <div className="mt-8 md:mt-10 space-y-4 text-ink/85 leading-relaxed text-sm md:text-base lg:text-[17px] max-w-xl">
                <p>{designer.intro}</p>
                {designer.bio.map((p, i) => (
                  <p key={i}>{p}</p>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default About;
